<template>
  <div class="p-3 flex flex-col bg-key rounded-4xl">
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-1 h-9 text-black-white text-l-medium">
        <Icon icon="Status-Wireframe-Day" class="size-6" />
        <span class="text-l-medium text-black-white">{{
          t('setting.device.brightness.title')
        }}</span>
      </div>
    </div>
    <div class="mt-1.5 pt-6 pb-4 relative flex flex-1 text-m-medium">
      <span class="font-[Barlow] text-text-glass-default">0%</span>
      <div class="relative w-full flex flex-1 mx-2">
        <Slider
          v-model="brightness"
          :min="0"
          :max="100"
          :step="1"
          class="w-full"
          track-class="h-3 bg-neutral-light-default"
          range-class="bg-brand-blue1"
          :thumb-class="`size-4.5 ${!brightness ? 'bg-blue-light-default' : 'bg-blue-dark-default'}`"
          @value-commit="commitBrightness"
        />
        <div
          class="absolute bottom-5 left-0 -translate-x-1/2 pointer-events-none text-center leading-none"
          :style="{ left: bubbleLeft }"
        >
          <div
            class="text-m-medium whitespace-nowrap font-[Barlow]"
            :class="!brightness ? 'text-text-disabled' : 'text-brand-blue1'"
          >
            {{ brightness[0] }}%
          </div>
        </div>
      </div>
      <span class="font-[Barlow] text-text-glass-default">100%</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { useDeviceStore } from '@/stores'
  import { Icon, Slider } from '@rapoo/element'
  import { storeToRefs } from 'pinia'
  import { computed, onMounted, ref } from 'vue'
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n()

  const brightness = ref([0])

  const deviceStore = useDeviceStore()
  const { currentDevice } = storeToRefs(deviceStore)
  const baseScreen = computed(() => {
    if (!currentDevice.value?.features) return null
    return currentDevice.value.features.baseScreen
  })
  const initBrightness = () => {
    if (!baseScreen.value) return
    baseScreen.value.getScreenBrightness().then((val) => {
      brightness.value = [val]
    })
  }
  onMounted(() => {
    initBrightness()
  })

  const commitBrightness = (val: number[]) => {
    if (!baseScreen.value) return
    baseScreen.value.setScreenBrightness(val[0]).then(() => {
      brightness.value = val
    })
  }
  const bubbleLeft = computed(() => {
    const min = 0
    const max = 100
    const value = brightness.value[0]
    const p = (value - min) / (max - min)

    // 16 为thumb宽度
    return `calc(${p * 100}% + ${(0.5 - p) * 16}px)`
  })
</script>
